import { FC } from 'react';
import { useSnapshot } from 'valtio';
import {
  setCommentModal,
  setIssueCommentTemp,
} from '../../active-issues/store-actions/issue-store-actions';
import IssuesStore from '../../active-issues/stores/issues-store';
import AddCommentModal from '../components/AddCommentModal';
import { addingComment } from '../../active-issues/actions/active-issues-actions';

const IssueCommentContainer: FC<React.PropsWithChildren<unknown>> = () => {
  const { commentModal, selectedIssue, isAddingCommentLoading } =
    useSnapshot(IssuesStore);

  const handleClose = () => {
    setCommentModal(false);
  };

  return (
    <AddCommentModal
      open={commentModal}
      onCloseAddingComment={handleClose}
      handleAddingComment={addingComment}
      isLoading={isAddingCommentLoading}
      comment={selectedIssue?.comment}
      issueName={selectedIssue?.mainTitle}
      setIssueCommentTemp={setIssueCommentTemp}
    />
  );
};

export default IssueCommentContainer;
